import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Position } from '../../models/cutting/cutting-svg.model';

@Component({
  selector: 'csl-base-point-select',
  templateUrl: './base-point-select.component.html',
  styleUrls: ['./base-point-select.component.scss'],
})
export class BasePointSelectComponent implements OnInit {
  activeSchema: { tl: boolean; tr: boolean; br: boolean; bl: boolean; c: boolean } = {
    tl: true,
    tr: true,
    br: true,
    bl: true,
    c: true,
  };

  @Input() disabled = false;

  @Input() showAxis = true;

  @Input() set disablePoints(val: Position[]) {
    this.activeSchema = { tl: true, tr: true, br: true, bl: true, c: true };

    val.forEach(p => {
      switch (p) {
        case 'tl':
          this.activeSchema.tl = false;
          break;
        case 'tr':
          this.activeSchema.tr = false;
          break;
        case 'br':
          this.activeSchema.br = false;
          break;
        case 'bl':
          this.activeSchema.bl = false;
          break;
        case 'c':
          this.activeSchema.c = false;
          break;
      }
    });
  }

  @Input() value: Position = 'bl';
  @Output() valueChange: EventEmitter<Position> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
